import React from 'react';
// import Cards from './components/Cards/Cards';
// import Chart from './components/Chart/Chart';
// import CountryPicker from './components/CountryPicker/CountryPicker';
import coronaImage from './images/image.png';
import {Cards,Chart, CountryPicker} from './components';
import {fetchData} from './api';
import Styles from './App.module.css';
class App extends React.Component{
    state ={
        data:{},
        country: '',
    }
    async componentDidMount(){
        const fetchedData = await fetchData();
        this.setState({data:fetchedData});

        // console.log(data);
    }
    handleCountryChange = async(country)=>{
        // fetch the data 
        const fetchedData = await fetchData(country);
        // set the state
        this.setState({data: fetchedData, country:country});

    }
    render(){
        const{data, country} = this.state;
        return(
            <div className={Styles.container}>
                <img className={Styles.image} src={coronaImage} alt="COVID-19" />
                <Cards data={data}></Cards>
                <CountryPicker handleCountryChange={this.handleCountryChange}></CountryPicker>
                <Chart data={data} country={country}></Chart>
                
            </div>
        )
    }
}

export default App;